module.exports = __webpack_public_path__ + "rating.69c1c73c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/headers/rating.png
// module id = 1728
// module chunks = 0